import { delay, put, select } from 'redux-saga/effects';
import { FOURSIGHT_MATCH_TICKERS_CALL } from 'constants/components';
import { getMatchSportId, getStreamUrls } from '../../reducers';
import { fetchFourSightContent } from '../../reducers/fourSightContent';
import disableElementsForFourSightStreams from '../../utils/generalTennisHelpers';

function* isFourSightStream(matchId) {
  const sportId = yield select(getMatchSportId, matchId);
  const streams = yield select(getStreamUrls);
  // For tests without real case, add ! before
  return disableElementsForFourSightStreams(sportId, streams);
}

function* loadFourSightContent(matchId) {
  yield put(fetchFourSightContent(matchId));
}

function* pollFourSightContent(matchId) {
  // TODO 2028 // optional logic for avoiding initial call for non-targeted sports/streams.
  //  Should be tested during QA/AT on stg env

  // Gate: only proceed if this is a FourSight tennis stream
  // const shouldLoad = yield* isFourSightStream(matchId);
  // if (!shouldLoad) {
  //   return;
  // }

  // Fetch at least once
  yield* loadFourSightContent(matchId);

  while (true) {
    yield delay(FOURSIGHT_MATCH_TICKERS_CALL);

    const isFoursight = yield* isFourSightStream(matchId);

    if (!isFoursight) {
      return;
    }

    yield* loadFourSightContent(matchId);
  }
}

export default pollFourSightContent;
